(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ask-founder-block"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__askFounderTracking) return;
    window.__askFounderTracking = true;

    // Show the status label only during availability hours.
    // Done in the browser (not Liquid) so cached pages never show a stale status.
    function updateStatus() {
      var nodes = document.querySelectorAll('[data-ask-founder-status]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var start = parseFloat(el.getAttribute('data-start'));
        var end = parseFloat(el.getAttribute('data-end'));
        var tz = el.getAttribute('data-tz') || 'America/Vancouver';
        var hour;

        try {
          var parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23'
          }).formatToParts(new Date());
          var h = 0;
          var m = 0;
          for (var j = 0; j < parts.length; j++) {
            if (parts[j].type === 'hour') h = Number(parts[j].value) % 24;
            if (parts[j].type === 'minute') m = Number(parts[j].value);
          }
          hour = h + m / 60;
        } catch (e) {
          continue;
        }

        var isOpen = hour >= start && hour < end;
        var text = isOpen
          ? el.getAttribute('data-open-text')
          : el.getAttribute('data-away-text');
        var label = el.querySelector('.ask-founder__status-text');

        if (!text) {
          el.hidden = true;
          continue;
        }

        if (label && label.textContent !== text) label.textContent = text;
        el.classList.toggle('is-away', !isOpen);
        el.hidden = false;
      }
    }

    var pending = false;
    function scheduleUpdate() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        updateStatus();
      });
    }

    updateStatus();
    document.addEventListener('DOMContentLoaded', updateStatus);
    document.addEventListener('shopify:section:load', updateStatus);
    setInterval(updateStatus, 60000);

    // Re-apply after the theme re-renders the product section (e.g. variant change)
    try {
      new MutationObserver(scheduleUpdate).observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {}

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ask-founder-track]');
      if (!link) return;

      var method = link.getAttribute('data-ask-founder-track');
      var product = link.getAttribute('data-product') || '';

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ask_founder_click',
          contact_method: method,
          product_title: product
        });
      } catch (e) {}

      try {
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'AskFounderClick', {
            contact_method: method,
            content_name: product
          });
        }
      } catch (e) {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
